import { StepProps } from '@betterment/js-runtime';
import { SuccessFullScreen } from '@betterment/samba-react';
import { ErrorBoundary } from '@betterment/shared-components';

import { WithLayout } from '../../RetailApp/components/WithLayout';
import { locationAssign } from '../../Shared/path-helpers';

export const SuccessStep: React.FC<StepProps> = ({ flowState }) => {
  return (
    <ErrorBoundary>
      <WithLayout parts={{ sidebar: false, footer: false }}>
        <SuccessFullScreen
          message="Your order has been submitted"
          onCompletion={() => locationAssign(flowState.returnToPath)}
        />
      </WithLayout>
    </ErrorBoundary>
  );
};
